import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Playlist from "../../Components/PlaylistView/Playlist";
import Header from "../../Base/Header";
import Footer from "../../Base/Footer";
import axios from "axios";
import styles from "./index.module.css";
import Loader from "react-js-loader";
import { API } from "../../backend";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

function Search() {
  let query = useQuery().get("query");
  const [searchPlaylist, setSearchPlaylist] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    var config = {
      method: "get",
      url: `${API}/playlist/getFilteredPlaylists?search=${query}`,
      headers: {
        "Content-Type": "application/json",
      },
    };
    axios(config)
      .then(function (response) {
        console.log(JSON.stringify(response.data));
        if ((response.data.status = "success")) {
          setSearchPlaylist(response.data.playlists);
          setLoading(false);
        }
      })
      .catch(function (error) {
        console.log(error.response.data.status);
        if (error.response.data.status === "fail") {
          setSearchPlaylist([]);
          setLoading(false);
        }
      });
  }, [query]);

  return (
    <div className={styles.container}>
      <Header />
      {loading ? (
        <Loader
          type="bubble-top"
          bgColor={"#000000"}
          color={"#000000"}
          title={"Loading Playlists"}
        />
      ) : (
        <>
          <div className={styles.playlistContainer}>
            {searchPlaylist && (
              <div className={styles.main}>
                <h1 className={styles.heading}>
                  {searchPlaylist.length > 0 && (
                    <>
                      Search Results for{" "}
                      <span className={styles.searchkey}>{query}</span>
                    </>
                  )}
                </h1>
                <div>
                  {searchPlaylist.length > 0 ? (
                    searchPlaylist.map((playlist) => {
                      return (
                        <div className={styles.playlist}>
                          <Playlist data={playlist} key={playlist._id} />
                        </div>
                      );
                    })
                  ) : (
                    <div>
                      <h3>
                        {" "}
                        <span>Oops😢</span> We could not find any playlists in "
                        {query}"
                      </h3>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        </>
      )}

      <Footer />
    </div>
  );
}

export default Search;
